// extracted by mini-css-extract-plugin
export var banner = "_qv-0";
export var settingRow = "_qv-2";
export var titleIcon = "_qv-1";